import React from "react";
import { LoadingPanel } from "../../components";
import {
  ActionContainer,
  InfoContainer,
  InfoSummary,
  InfoSummaryContainer,
  MuiSkeleton,
} from "./style";

interface Props {
  isAr: boolean;
}

const DetailPlaceholder = ({ isAr }: Props) => {
  const alignItems = isAr ? "end" : "start";
  const flexDirection = isAr ? "row-reverse" : "row";

  return (
    <React.Fragment>
      <LoadingPanel position="absolute" isOpen backdropInvisible />
      <ActionContainer style={{ flexDirection, alignItems: "end" }}>
        <InfoContainer
          style={{ display: "flex", flexDirection: "column", alignItems }}
        >
          <MuiSkeleton variant="text" width="250px" height="24px" />
          <MuiSkeleton variant="text" width="80%" height="24px" />
          <MuiSkeleton variant="text" width="80%" height="24px" />
          <MuiSkeleton variant="text" width="80%" height="24px" />
          <InfoSummaryContainer>
            <InfoSummary>
              <MuiSkeleton variant="text" width="32px" height="16px" />
            </InfoSummary>
            <InfoSummary>
              <MuiSkeleton variant="text" width="24px" height="16px" />
            </InfoSummary>
            <InfoSummary>
              <MuiSkeleton variant="text" width="24px" height="16px" />
            </InfoSummary>
            <InfoSummary>
              <MuiSkeleton variant="text" width="24px" height="16px" />
            </InfoSummary>
          </InfoSummaryContainer>
        </InfoContainer>
        <MuiSkeleton variant="rect" width="114px" height="38px" />
      </ActionContainer>
    </React.Fragment>
  );
};

export default DetailPlaceholder;
